import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { CheckDefaultRelatedCompanionResponse, PatientRelatedCompanionListOption, PatientRelatedCompanionListOptionRequest } from '../models/related-companions';

@Injectable({
  providedIn: 'root'
})
export class RelatedCompanionDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public checkDefaultRelatedCompanionExists(patientId: number, companionId: number, relatedCompanionId?: number, cancellationToken?: Promise<any>): Promise<CheckDefaultRelatedCompanionResponse> {
    const data = { patientId: patientId, companionId: companionId, relatedCompanionId: relatedCompanionId };

    return this.httpClient.getJsonAsync<CheckDefaultRelatedCompanionResponse>('relatedCompanions/checkDefaultRelatedCompanionExists', data, cancellationToken);
  }

  public checkSelfResponsiblePartyExists(patientId: number, relationToCompanionId: number, relatedCompanionId: number, timeout: Promise<any>): Promise<boolean> {
    const data = { patientId: patientId, relationToCompanionId: relationToCompanionId, relatedCompanionId: relatedCompanionId };

    return this.httpClient.getJsonAsync<boolean>('relatedCompanions/checkSelfResponsiblePartyExists', data, timeout, false);
  }

  public getPatientRelatedCompanionListOptionsAsync(patientId: number, cancellation: Promise<any>): Promise<PatientRelatedCompanionListOption[]> {
    const request = {} as PatientRelatedCompanionListOptionRequest;
    request.patientId = patientId;

    return this.httpClient.getJsonAsync<PatientRelatedCompanionListOption[]>('relatedCompanions/PatientRelatedCompanionListOptions', request, cancellation);
  }
}
